import gql from 'graphql-tag';

const User = gql`
  query currentUser{
    currentUser {
      ... on ClientUser {
        id
        profile {
          firstname
          email
          phone
        }
        balanceEUR: balance {
          approved: sum(currency: EUR, status: [completed])
          hold: sum(currency: EUR, status: [pending], type: [withdrawals_order])
        }
        balanceUSD: balance {
          approved: sum(currency: USD, status: [completed])
          hold: sum(currency: USD, status: [pending], type: [withdrawals_order])
        }
        balanceRUB: balance {
          approved: sum(currency: RUB, status: [completed])
          hold: sum(currency: RUB, status: [pending], type: [withdrawals_order])
        }
      }
    }
  }
`;

export const UpdateUser = gql`
mutation updateUser(
  $userId: ID!,
  $profile: UserProfileInput,
) {
  updateUser(id: $userId, data: {
    profile: $profile
  }) {
    user {
      ... on ClientUser {
        id
        profile {
          firstname
          phone
          email
        }
        balanceEUR: balance {
          approved: sum(currency: EUR, status: [completed])
          hold: sum(currency: EUR, status: [pending], type: [withdrawals_order])
        }
        balanceUSD: balance {
          approved: sum(currency: USD, status: [completed])
          hold: sum(currency: USD, status: [pending], type: [withdrawals_order])
        }
        balanceRUB: balance {
          approved: sum(currency: RUB, status: [completed])
          hold: sum(currency: RUB, status: [pending], type: [withdrawals_order])
        }
      }
    }
    status
  }
}
`;

export default User;



// WEBPACK FOOTER //
// ./src/views/Profile/graphql/User.js